// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1Mcij","containerItemsCenter":"Skeleton_containerItemsCenter__2tydK"};